export default __webpack_public_path__ + "static/media/round-chevron.a5d1e8ae.svg";